"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    phoneNumberWithCountryCode: {
        countryCode: "+1",
    },
};
